import { render } from "./ButtonLime.vue?vue&type=template&id=15f6bac7&scoped=true"
import script from "./ButtonLime.vue?vue&type=script&lang=js"
export * from "./ButtonLime.vue?vue&type=script&lang=js"

import "./ButtonLime.vue?vue&type=style&index=0&id=15f6bac7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-15f6bac7"

export default script